import React, { useState } from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { subscribeNewsletter } from "../services/api";
import Swal from "sweetalert2";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    "gallery_1.jpg",
    "gallery_2.jpg",
    "gallery_3.jpg",
    "gallery_4.jpg",
    "gallery_5.jpg",
    "gallery_6.jpg",
  ];

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);

    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      Swal.fire({
        title: "Error!",
        text: "Please enter a valid email address.",
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading(false);
      return;
    }

    try {
      const response = await subscribeNewsletter(trimmedEmail);
      Swal.fire({
        title: "Success!",
        text: response?.message || "Email subscribed successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
      setEmail("");
    } catch (err) {
      Swal.fire({
        title: "Error!",
        text:
          err.response?.data?.message || "An error occurred. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  const openLightbox = (img) => setSelectedImage(img);
  const closeLightbox = () => setSelectedImage(null);

  return (
    <footer
      className="footer-wrapper footer-layout5 bg-title"
      id="contact-sec"
      style={{ backgroundColor: "#0a1a3d" }}
    >
      <style>{`
        /* Logo proportional size */
        .footer-logo img {
          max-width: 100px;
          height: auto;
          display: block;
          margin: 0 auto;
        }
        @media (max-width: 768px) {
          .footer-logo img {
            max-width: 80px;
          }
        }

        /* Newsletter */
        .subscribe-box_text {
          font-size: 0.85rem;
          letter-spacing: 0.5px;
          text-transform: none;
          color: #e86b24;
          margin-bottom: 0.2rem;
        }
        .subscribe-box_title {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 0;
          color: #fff;
        }

        /* Widget titles and text */
        .widget_title {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: 1rem;
          position: relative;
          padding-bottom: 0.5rem;
          color: #fff !important;
        }
        .widget_title::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 2px;
          background: #e86b24;
        }

        /* Override all footer widget text to white */
        .footer-wrapper .widget-area .widget,
        .footer-wrapper .widget-area .widget *,
        .footer-wrapper .widget-area .info-box_text,
        .footer-wrapper .widget-area .info-box_link,
        .footer-wrapper .widget-area .menu li a,
        .footer-wrapper .widget-area .menu li,
        .footer-wrapper .widget-area p,
        .footer-wrapper .widget-area span {
          color: #fff !important;
        }

        .th-widget-about p {
          font-size: 0.9rem;
          line-height: 1.6;
        }

        .th-widget-contact .info-box_text,
        .th-widget-contact .info-box_link {
          font-size: 0.9rem;
        }

        .widget_nav_menu .menu li a {
          font-size: 0.9rem;
          transition: color 0.3s, background 0.2s;
          text-decoration: none;
        }
        .widget_nav_menu .menu li a:hover {
          color: #e86b24 !important;
        }

        .th-social.style3 a {
          color: #fff;
          margin-right: 12px;
          transition: color 0.3s;
        }
        .th-social.style3 a:hover {
          color: #e86b24;
        }

        /* Gallery images */
        .gallery-img {
          width: 75px;
          height: 75px;
          object-fit: cover;
          border-radius: 4px;
          transition: transform 0.3s ease;
          cursor: pointer;
        }
        .gallery-thumb:hover .gallery-img {
          transform: scale(1.05);
        }

        /* Copyright */
        .copyright-text {
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.8);
        }
        .footer-links ul li a {
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.8);
          transition: color 0.3s;
          text-decoration: none;
        }
        .footer-links ul li a:hover {
          color: #e86b24;
        }

        /* Lightbox styles */
        .lightbox-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.85);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.2s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .lightbox-content {
          position: relative;
          max-width: 85vw;
          max-height: 80vh;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.3);
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .lightbox-content img {
          display: block;
          max-width: 100%;
          max-height: 80vh;
          object-fit: contain;
        }
        .lightbox-close {
          position: absolute;
          top: 12px;
          right: 12px;
          background: #e86b24;
          color: #fff;
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          font-size: 1.2rem;
          cursor: pointer;
          box-shadow: 0 4px 10px rgba(0,0,0,0.3);
          transition: background 0.2s;
          z-index: 5;
        }
        .lightbox-close:hover {
          background: #d2551a;
        }

        @media (max-width: 768px) {
          .subscribe-box {
            flex-direction: column;
            text-align: center;
          }
          .subscribe-box .newsletter-form {
            width: 100%;
            margin-top: 1rem;
          }
        }
      `}</style>

      {/* Footer Top – Newsletter */}
      <div className="footer-top">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-3">
              <div className="footer-logo">
                <img src="/assets/img/logofooter.png" alt="Sagama" />
              </div>
            </div>
            <div className="col-xl-9">
              <div className="subscribe-box">
                <div>
                  <p className="subscribe-box_text">
                    GET EXCLUSIVE OFF-MARKET DEALS & UPDATES
                  </p>
                  <h4 className="subscribe-box_title">
                    Never Miss an Opportunity
                  </h4>
                </div>
                <form className="newsletter-form" onSubmit={handleSubscribe}>
                  <input
                    className="form-control style-radious"
                    type="email"
                    placeholder="Enter Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button
                    type="submit"
                    className="th-btn style3 style-new shadow-none"
                    disabled={loading}
                  >
                    {loading ? (
                      <i className="fas fa-spinner fa-spin ms-2"></i>
                    ) : (
                      <>
                        SUBSCRIBE<i className="fas fa-arrow-right ms-2"></i>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Widget Area */}
      <div className="widget-area">
        <div className="container">
          <div className="row justify-content-between">
            {/* About Sagama */}
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <h3 className="widget_title">About Sagama</h3>
                <div className="th-widget-about">
                  <p className="about-text">
                    Sagama Homes is a premier, privately-owned real estate
                    developer dedicated to creating signature residential and
                    commercial properties. We don’t just build houses; we curate
                    exclusive lifestyles in Abuja’s most sought-after locations.
                  </p>
                  <div className="th-social style3">
                    <Link
                      to="https://www.youtube.com/@SagamaHomes"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube"></i>
                    </Link>
                    <Link
                      to="https://www.facebook.com/sagamahomes"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </Link>
                    <Link
                      to="https://x.com/SagamaHomes"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-twitter"></i>
                    </Link>
                    <Link
                      to="https://www.linkedin.com/company/sagamahomes/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </Link>
                    <Link
                      to="https://www.instagram.com/sagamahomes/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Quick Links</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/services">Services & Engineering</Link>
                    </li>
                    <li>
                      <Link to="/top-estates">Estates</Link>
                    </li>
                    <li>
                      <Link to="/blog">Blog & News</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <h3 className="widget_title">Contact Now</h3>
                <div className="th-widget-contact">
                  <div className="info-box-wrap">
                    <div className="info-box_icon">
                      <i className="fas fa-location-dot"></i>
                    </div>
                    <p className="info-box_text">
                      CON Oil Mega Filling Station, Kado Estate FCT, Abuja,
                      Nigeria
                    </p>
                  </div>
                  <div className="info-box-wrap">
                    <div className="info-box_icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <Link
                      to="mailto:sagamaconstruction125@gmail.com"
                      className="info-box_link"
                    >
                      sagamaconstruction125@gmail.com
                    </Link>
                  </div>
                  <div className="info-box-wrap">
                    <div className="info-box_icon">
                      <i className="fas fa-phone"></i>
                    </div>
                    <div>
                      <span style={{ fontSize: "0.8rem", color: "#ccc" }}>
                        Sales & Inquiries:
                      </span>
                      <br />
                      <Link to="tel:07055558942" className="info-box_link">
                        07055558942
                      </Link>
                    </div>
                  </div>
                  <div className="info-box-wrap">
                    <div className="info-box_icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div>
                      <span style={{ fontSize: "0.8rem", color: "#ccc" }}>
                        24/7 Virtual Support via Email:
                      </span>
                      <br />
                      <Link
                        to="mailto:sagamaconstruction125@gmail.com"
                        className="info-box_link"
                      >
                        sagamaconstruction125@gmail.com
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Gallery Posts */}
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <h4 className="widget_title">Gallery Posts</h4>
                <div className="sidebar-gallery">
                  {galleryImages.map((img, idx) => (
                    <div className="gallery-thumb" key={idx}>
                      <img
                        src={`/assets/img/gallery/${img}`}
                        alt={`Gallery ${idx + 1}`}
                        className="gallery-img"
                        loading="lazy"
                        onClick={() => openLightbox(img)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal – refined */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="lightbox-close" onClick={closeLightbox}>
              ✕
            </button>
            <img
              src={`/assets/img/gallery/${selectedImage}`}
              alt="Gallery preview"
            />
          </div>
        </div>
      )}

      <ScrollToTop />

      {/* Copyright */}
      <div className="copyright-wrap">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6">
              <p className="copyright-text">
                Copyright <i className="fal fa-copyright"></i> 2026{" "}
                <Link to="/" style={{ color: "#e86b24" }}>
                  Sagama
                </Link>
                . All Rights Reserved. | Powered By{" "}
                <Link to="https://syroltech.com" style={{ color: "#e86b24" }}>
                  Syrol Tech
                </Link>
              </p>
            </div>
            <div className="col-lg-6 text-end d-none d-lg-block">
              <div className="footer-links">
                <ul>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-of-use">Terms of Use</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
